var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCslogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2",
    "data-name": "Group 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 328.505,
    height: 77.137,
    viewBox: "0 0 328.505 77.137",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 328.505,
    height: 77.137,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M.34,28.354C2.7,13.515,16.639-2,34.6.21c10.664,1.311,13.659,7.9,12.656,15.048-1.058,7.533-3.669,6.688-2.557-1.231C45.509,8.233,43.339,3.25,35.325,2,18.954-.534,5.836,13.638,3.326,28.525,1.632,38.6,5.654,52.324,18.286,55.579a16.97,16.97,0,0,0,2.518.506c12.178,1.5,27.035-7.614,30.621-18.7.135-.966,1.51.71.58,3.346-3.729,10.61-16.35,18.752-30.8,16.976-.963-.119-1.918-.3-2.941-.492C5.149,54.423-1.647,41.012.34,28.354",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M106.679,54.5c-1.518-2.242-2.077-7.549-2.077-13.753,0-12.409,2.236-28.479,3.275-31.619.08-.448.559-.523,1.358-.224.8.374,1.437.972,1.437,1.346-.479,1.42-2.8,19.36-2.8,32.291,0,6.653.639,11.96,2.4,13.081,4.153,2.392,13.819-9.791,15.017-11.211.8-1.046.958.822.639,1.719-1.438,3.738-7.828,11.81-12.86,11.81a8.068,8.068,0,0,1-6.39-3.439",
    transform: "translate(-48.662 -4.361)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M142.189,80.191a6.545,6.545,0,0,1-.4-2.167,6.669,6.669,0,0,1,6.31-6.8c2.476,0,4.793,2.243,3.914,4.41-1.038,2.392-4.473,4.186-7.269,4.186.241,1.42,3.035,3.812,5.831,3.812,7.508,0,13.1-5.233,16.455-8.522,1.838-1.794,1.518-.075.4,2.018a16.07,16.07,0,0,1-12.861,8.3c-4.713.224-10.783-.6-12.381-5.233m2.476-2.167c3.355-1.42,5.592-3.439,4.713-4.261-1.677-1.569-4.792,2.392-4.713,4.261",
    transform: "translate(-65.962 -35.579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M188.092,74.923a14.19,14.19,0,0,1,.319-3.214c.08-.523.8-.748,1.6-.374.48.3,1.118,1.046.958,1.569-.319,2.318,0,8.073,1.6,9.867,1.438-.075,3.994-5.756,4.792-7.924a2.762,2.762,0,0,1,.879-3.214c.958-.374,2.716.9,2,3.139v.075a16.431,16.431,0,0,0,4.792.673,54.349,54.349,0,0,0,7.349-.673c2.077-.3.639,1.495-1.118,2.093a25.042,25.042,0,0,1-6.71.9c-2,0-3.914-.225-5.032-1.046-.879,2.765-2.956,6.727-4.953,7.325-1.358.373-2.4.673-3.595-.448a13.383,13.383,0,0,1-2.875-8.746",
    transform: "translate(-87.502 -35.543)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M229.116,80.191a6.545,6.545,0,0,1-.4-2.167,6.669,6.669,0,0,1,6.31-6.8c2.476,0,4.793,2.243,3.914,4.41-1.038,2.392-4.473,4.186-7.269,4.186.24,1.42,3.036,3.812,5.831,3.812,7.508,0,13.1-5.233,16.455-8.522,1.838-1.794,1.518-.075.4,2.018a16.068,16.068,0,0,1-12.86,8.3c-4.713.224-10.783-.6-12.381-5.233m2.476-2.167c3.355-1.42,5.592-3.439,4.713-4.261-1.677-1.569-4.792,2.392-4.713,4.261",
    transform: "translate(-106.402 -35.579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M275.751,70.631c0-.523.8-.523,1.6-.15a2.186,2.186,0,0,1,1.2,1.57l-.08,2.915c2-2.392,7.908-6.727,12.3-6.055,1.838.3,2.956,1.869,2.4,2.467-1.118,1.2-2.236.748-2.157.15l.08-.6c-3.994-.075-10.624,4.484-12.54,9.642a16.313,16.313,0,0,0-.559,3.214c.08.971-2.556,0-2.875-1.121-.32-.673-.48-2.616.639-12.034",
    transform: "translate(-127.876 -34.39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M316.056,79.439a13.174,13.174,0,0,0,2.636.224,41.657,41.657,0,0,0,7.828-.822c-2-.972-5.032-2.392-6.631-3.214-2.077-1.121-4.313-1.868-4.632-4.111-.64-3.962,8.068-6.353,12.141-6.877,1.278-.15,2.875,1.271,2.235,2.018-2.955.972-10.223,2.243-11.1,4.186-.479,1.046,1.357,1.794,2.956,2.691a57.305,57.305,0,0,1,7.029,3.887c1.757,1.42.24,3.513-1.837,4.036a23.878,23.878,0,0,1-5.591.6,16.045,16.045,0,0,1-5.111-.673c-.959-.448-1.678-2.317.079-1.943",
    transform: "translate(-146.534 -32.285)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M346.195,51.984a8.088,8.088,0,0,1-6.949-3.887c-2.476-3.812-3.275-9.867-3.275-16a80.2,80.2,0,0,1,.479-8.969l-22.137.286c-1.438-.149-.24-2.392,1.278-2.392,2.635,0,17.424-.137,21.179-.212a52.537,52.537,0,0,1,1.357-7.325c2-6.952,4.793-11.362,9.345-11.586,5.033-.3,6.55,3.887,6.55,8.671a31.786,31.786,0,0,1-1.438,9.045l-.239.673c4.793-.225,4.267-.144,9.379-.518,5.272-.448,5.464,1.781,1.629,2.155-6.15.6-6.536.455-11.808.755-2.156,6.129-5.192,12.782-11.981,19.06.958,4.933,2.636,8.148,5.112,8.222,5.75.15,13.578-8.969,15.495-12.184.24-.373,1.119-.149.719,1.644-.719,2.916-6.07,10.465-11.342,12.034a11.177,11.177,0,0,1-3.355.523m-6.949-28.852a73.143,73.143,0,0,0-.559,9.119,63.334,63.334,0,0,0,.4,7.026,41.557,41.557,0,0,0,9.585-16.444Zm.4-2.392c2.955-.075,6.31-.15,9.745-.3a19.163,19.163,0,0,1,.558-2.018,33.815,33.815,0,0,0,1.279-8.447c0-3.513-.879-6.2-3.355-6.054-3.754.224-5.67,4.709-6.949,10.09-.559,2.242-.959,4.56-1.278,6.727",
    transform: "translate(-145.921 -0.943)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M545.147,70.631c0-.523.8-.523,1.6-.15a2.187,2.187,0,0,1,1.2,1.57l-.08,2.915c2-2.392,7.908-6.727,12.3-6.055,1.837.3,2.955,1.869,2.4,2.467-1.118,1.2-2.236.748-2.157.15l.08-.6c-3.993-.075-10.623,4.484-12.54,9.642a16.311,16.311,0,0,0-.559,3.214c.08.971-2.556,0-2.875-1.121-.319-.673-.479-2.616.639-12.034",
    transform: "translate(-253.202 -34.39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M595.574,109.456c0-.822-.08-1.72-.08-2.766,0-6.727.638-17.416,1.357-26.461a7.249,7.249,0,0,1-4.872,2.317c-3.834,0-6.47-3.886-6.789-7.773.08-2.167.8-4.484,2.156-4.933a2,2,0,0,1,1.837.747c.72.6.88,1.271.32,1.42a2.841,2.841,0,0,0-.959,1.271,7.269,7.269,0,0,0-.478,2.616,7.672,7.672,0,0,0,.558,2.99c.64,1.122,1.358,1.795,2.875,1.2,3.675-1.345,5.673-5.83,6.152-9.268.079-1.046,2.556-.075,2.876,1.121a10.018,10.018,0,0,1-.24,5.008c-1.2,11.362-1.917,22.2-2.4,34.608.16.523-.56.6-1.2.224a3.359,3.359,0,0,1-1.118-2.317",
    transform: "translate(-272.237 -34.87)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M477.205,36.479a3.4,3.4,0,1,1-3.391-3.173,3.288,3.288,0,0,1,3.391,3.173",
    transform: "translate(-218.846 -16.638)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M490.421,44.671a2.571,2.571,0,1,1-2.565-2.4,2.486,2.486,0,0,1,2.565,2.4",
    transform: "translate(-225.763 -21.117)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M470.169,13.42a2.777,2.777,0,0,1-5.541,0,2.777,2.777,0,0,1,5.541,0",
    transform: "translate(-216.15 -5.409)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M457.94,39.251a2.793,2.793,0,1,1-2.787-2.608,2.7,2.7,0,0,1,2.787,2.608",
    transform: "translate(-210.445 -18.305)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M444.085,37.408a2.566,2.566,0,1,1-2.561-2.4,2.482,2.482,0,0,1,2.561,2.4",
    transform: "translate(-204.211 -17.49)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M433.4,45a2.22,2.22,0,1,1-2.216-2.073A2.148,2.148,0,0,1,433.4,45",
    transform: "translate(-199.562 -21.443)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M420.353,50.319a1.786,1.786,0,1,1-1.782-1.667,1.728,1.728,0,0,1,1.782,1.667",
    transform: "translate(-193.895 -24.304)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M430.715,33.346a1.786,1.786,0,1,1-1.782-1.667,1.728,1.728,0,0,1,1.782,1.667",
    transform: "translate(-198.715 -15.825)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M444.769,54.343a1.786,1.786,0,1,1-1.782-1.667,1.728,1.728,0,0,1,1.782,1.667",
    transform: "translate(-205.254 -26.315)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M451.463,26.656A2.17,2.17,0,1,1,449.3,24.63a2.1,2.1,0,0,1,2.165,2.026",
    transform: "translate(-208.011 -12.304)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M465.645,27.654a1.813,1.813,0,1,1-1.809-1.693,1.754,1.754,0,0,1,1.809,1.693",
    transform: "translate(-214.94 -12.969)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M489.382,17.677a1.788,1.788,0,1,1-1.785-1.67,1.73,1.73,0,0,1,1.785,1.67",
    transform: "translate(-226.006 -7.996)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M501.649,37.98a1.788,1.788,0,1,1-1.785-1.67,1.73,1.73,0,0,1,1.785,1.67",
    transform: "translate(-231.712 -18.139)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M514.952,35.519a1.788,1.788,0,1,1-1.785-1.67,1.73,1.73,0,0,1,1.785,1.67",
    transform: "translate(-237.901 -16.909)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M521.98,46.777a2.012,2.012,0,1,1-2.008-1.879,1.947,1.947,0,0,1,2.008,1.879",
    transform: "translate(-240.963 -22.429)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M478.419,22.41a2.211,2.211,0,1,1-2.206-2.064,2.139,2.139,0,0,1,2.206,2.064",
    transform: "translate(-220.513 -10.164)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M439.222,23.679a3.061,3.061,0,1,1-3.055-2.859,2.961,2.961,0,0,1,3.055,2.859",
    transform: "translate(-201.489 -10.401)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M491.574,122.7a3.061,3.061,0,1,1-3.055-2.859,2.961,2.961,0,0,1,3.055,2.859",
    transform: "translate(-225.844 -59.869)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M522.115,93.887a3.061,3.061,0,1,1-3.054-2.859,2.961,2.961,0,0,1,3.054,2.859",
    transform: "translate(-240.052 -45.474)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M516.4,57.491a3.061,3.061,0,1,1-3.055-2.859,2.961,2.961,0,0,1,3.055,2.859",
    transform: "translate(-237.395 -27.292)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M509.646,46.715a2.525,2.525,0,1,1-2.519-2.358,2.442,2.442,0,0,1,2.519,2.358",
    transform: "translate(-234.749 -22.159)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M490.277,30.89a1.452,1.452,0,1,1-1.449-1.356,1.4,1.4,0,0,1,1.449,1.356",
    transform: "translate(-226.734 -14.754)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M454.071,16.651a1.452,1.452,0,1,1-1.449-1.356,1.4,1.4,0,0,1,1.449,1.356",
    transform: "translate(-209.89 -7.641)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M500.155,56.042a2.029,2.029,0,1,1-2.025-1.895,1.963,1.963,0,0,1,2.025,1.895",
    transform: "translate(-230.794 -27.049)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M516.335,70.837a2.527,2.527,0,1,1-2.521-2.36,2.445,2.445,0,0,1,2.521,2.36",
    transform: "translate(-237.858 -34.208)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M504.936,84.571a2.527,2.527,0,1,1-2.522-2.36,2.445,2.445,0,0,1,2.522,2.36",
    transform: "translate(-232.555 -41.069)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M527.351,65.13a1.659,1.659,0,1,1-1.656-1.549,1.605,1.605,0,0,1,1.656,1.549",
    transform: "translate(-243.789 -31.762)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M527.351,78.043a1.659,1.659,0,1,1-1.656-1.549,1.605,1.605,0,0,1,1.656,1.549",
    transform: "translate(-243.789 -38.213)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M518.305,84a1.916,1.916,0,1,1-1.912-1.789A1.853,1.853,0,0,1,518.305,84",
    transform: "translate(-239.342 -41.066)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M509.567,93.9a1.916,1.916,0,1,1-1.912-1.789,1.854,1.854,0,0,1,1.912,1.789",
    transform: "translate(-235.277 -46.017)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M503.884,69.271a1.583,1.583,0,1,1-1.58-1.478,1.531,1.531,0,0,1,1.58,1.478",
    transform: "translate(-232.943 -33.866)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M514.687,107.04a1.583,1.583,0,1,1-1.58-1.478,1.532,1.532,0,0,1,1.58,1.478",
    transform: "translate(-237.968 -52.734)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M502.807,117.628a1.583,1.583,0,1,1-1.58-1.478,1.531,1.531,0,0,1,1.58,1.478",
    transform: "translate(-232.442 -58.023)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M494.337,96.451a1.583,1.583,0,1,1-1.58-1.478,1.532,1.532,0,0,1,1.58,1.478",
    transform: "translate(-228.501 -47.444)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M505.323,105.312a1.957,1.957,0,1,1-1.953-1.828,1.893,1.893,0,0,1,1.953,1.828",
    transform: "translate(-233.265 -51.696)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M492.141,109.11a2.531,2.531,0,1,1-2.525-2.364,2.448,2.448,0,0,1,2.525,2.364",
    transform: "translate(-226.599 -53.326)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M478.885,102.755a3.012,3.012,0,1,1-3.006-2.812,2.914,2.914,0,0,1,3.006,2.812",
    transform: "translate(-219.986 -49.927)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M467.6,113.239a2.635,2.635,0,1,1-2.63-2.461,2.549,2.549,0,0,1,2.63,2.461",
    transform: "translate(-215.085 -55.34)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M480.717,117.28a1.957,1.957,0,1,1-1.953-1.828,1.893,1.893,0,0,1,1.953,1.828",
    transform: "translate(-221.818 -57.675)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M472.426,126.141a1.957,1.957,0,1,1-1.953-1.828,1.893,1.893,0,0,1,1.953,1.828",
    transform: "translate(-217.961 -62.101)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M459.9,125.23a1.957,1.957,0,1,1-1.953-1.828,1.893,1.893,0,0,1,1.953,1.828",
    transform: "translate(-212.134 -61.646)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M453.37,114.368a1.957,1.957,0,1,1-1.953-1.828,1.893,1.893,0,0,1,1.953,1.828",
    transform: "translate(-209.096 -56.22)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M441.138,117.628a1.583,1.583,0,1,1-1.58-1.478,1.531,1.531,0,0,1,1.58,1.478",
    transform: "translate(-203.753 -58.023)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M432.156,109.993a1.583,1.583,0,1,1-1.58-1.478,1.532,1.532,0,0,1,1.58,1.478",
    transform: "translate(-199.574 -54.209)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M444.928,104.016a2.613,2.613,0,1,1-2.607-2.44,2.527,2.527,0,0,1,2.607,2.44",
    transform: "translate(-204.559 -50.743)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M460.047,100.6a3.089,3.089,0,1,1-3.083-2.885,2.989,2.989,0,0,1,3.083,2.885",
    transform: "translate(-211.151 -48.817)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M432.351,95.741a3.089,3.089,0,1,1-3.082-2.885,2.989,2.989,0,0,1,3.082,2.885",
    transform: "translate(-198.267 -46.387)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M428.757,82.226a1.839,1.839,0,1,1-1.835-1.718,1.779,1.779,0,0,1,1.835,1.718",
    transform: "translate(-197.755 -40.218)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M421.1,93.622a1.839,1.839,0,1,1-1.835-1.718,1.779,1.779,0,0,1,1.835,1.718",
    transform: "translate(-194.192 -45.911)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M417.667,81.779a1.839,1.839,0,1,1-1.835-1.718,1.779,1.779,0,0,1,1.835,1.718",
    transform: "translate(-192.596 -39.995)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M423.729,71.208a2.129,2.129,0,1,1-2.124-1.988,2.059,2.059,0,0,1,2.124,1.988",
    transform: "translate(-195.147 -34.579)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M443.447,90.4A2.455,2.455,0,1,1,441,88.108a2.375,2.375,0,0,1,2.45,2.293",
    transform: "translate(-204.017 -44.015)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M439.226,70.313a3.089,3.089,0,1,1-3.083-2.885,2.989,2.989,0,0,1,3.083,2.885",
    transform: "translate(-201.465 -33.684)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M430.828,58.452a2.654,2.654,0,1,1-2.648-2.478,2.567,2.567,0,0,1,2.648,2.478",
    transform: "translate(-197.962 -27.962)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M420.353,50.319a1.786,1.786,0,1,1-1.782-1.667,1.728,1.728,0,0,1,1.782,1.667",
    transform: "translate(-193.895 -24.304)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M416.99,62.139a1.548,1.548,0,1,1-1.544-1.445,1.5,1.5,0,0,1,1.544,1.445",
    transform: "translate(-192.551 -30.32)",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M502.629,21.777a3.061,3.061,0,1,1-3.055-2.859,2.961,2.961,0,0,1,3.055,2.859",
    transform: "translate(-230.987 -9.451)",
    fill: "#ffc347"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCslogo);
export default __webpack_public_path__ + "static/media/cslogo.9a3fb81b220fa6d38f74c2128b7052f9.svg";
export { ForwardRef as ReactComponent };